import React from 'react';
import PropTypes from 'prop-types';
import BasicComponent from '../../../core/basic-component';

export default class RenderComponentProto extends BasicComponent {

    static props = {
        id: PropTypes.string, // custom field id
        value: PropTypes.any,
        renderType: PropTypes.oneOf(['default', 'list', 'view']),

        canEdit: PropTypes.bool,
        onChange: PropTypes.func,

        // old
        params: PropTypes.object,
        onFocusCallback: PropTypes.func,
        onBlurCallback: PropTypes.func,
        stateless: PropTypes.bool // ????
    };

    static defaultProps = {
        // default props are applied only for self class, not for the extended classes
    };

    constructor(props) {
        super(props);

        this.state = {
            value: props.value
        };

        this._bind('onChange');
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.state.value !== newProps.value)
            this.setState({value: newProps.value});
    }

    onChange(newValue) {
        this.setState({value: newValue}, ()=>{
            if (this.props.onChange) this.props.onChange(newValue)
        });
    }

    render() {
        return <div>Not implemented</div>;
    }
}